import { render, staticRenderFns } from "./CandidateRequest.vue?vue&type=template&id=704ad588"
import script from "./CandidateRequest.vue?vue&type=script&lang=js"
export * from "./CandidateRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports